import { Component, Vue } from "vue-property-decorator";
import { QuotationRevision } from "@/models";
import { camelToUnderscore } from "@/utils/Typography";

@Component
export default class ExportssMixin extends Vue {
  readonly qrPath = camelToUnderscore("exports");

  getExport(
    id: number | string,
    tag,
    opts?: { fields?: { [key: string]: string }; include?: string }
  ) {
    const path = `${this.qrPath}`;
    const routes = this.$getModelRoutes(path);
    return this.$httpGet(routes.getUrl(id, opts), tag);
  }
}
